module.exports = __webpack_public_path__ + "static/m_solution9-38413bc23bbac30592739b229b9a1793.png";